interface ACTIONS {
  type: string;
  payload: any;
}

export const SET_NEW_NOTIFICATIONS = 'SET_NEW_NOTIFICATIONS';
export const SET_REFRESH_NOTIFICATIONS = 'SET_REFRESH_NOTIFICATIONS';
export const SET_START_NOTIFICATIONS_API_POLLING = 'SET_START_NOTIFICATIONS_API_POLLING';
export const SET_SHOW_OLD_NOTIFICATIONS = 'SET_SHOW_OLD_NOTIFICATIONS';

export const setNewNotifications = (value: any) => ({
  type: SET_NEW_NOTIFICATIONS,
  payload: value,
});

export const setRefreshNotifications = (value: number) => ({
  type: SET_REFRESH_NOTIFICATIONS,
  payload: value,
});

export const setStartNotificationApiPolling = (value: boolean) => ({
  type: SET_START_NOTIFICATIONS_API_POLLING,
  payload: value,
});

export const setShowOldNotifications = (value: boolean) => ({
  type: SET_SHOW_OLD_NOTIFICATIONS,
  payload: value,
});

const initialState = {
  newNotifications: [],
  refreshNotifications: 0,
  startNotificationsApiPolling: false,
  showOldNotifications: true,
};

const notificationsReducer = (state = initialState, action: ACTIONS) => {
  switch (action.type) {
    case SET_NEW_NOTIFICATIONS:
      return { ...state, newNotifications: action.payload };
    case SET_REFRESH_NOTIFICATIONS:
      return { ...state, refreshNotifications: action.payload };
    case SET_START_NOTIFICATIONS_API_POLLING:
      return { ...state, startNotificationsApiPolling: action.payload };
    case SET_SHOW_OLD_NOTIFICATIONS:
      return { ...state, showOldNotifications: action.payload };
    default:
      return state;
  }
};

export default notificationsReducer;
